
  const { hot } = require("react-hot-loader/root")
  import Component from "/codebuild/output/src118104120/src/src/views/components/card-slider/index.tsx"

  export default hot(Component)
  